import React from "react";

export const SettingsLayout = React.lazy(
  () => import("@/features/settings/pages/SettingsLayoutPage.tsx"),
);
